/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */
import React, { useContext, useEffect, useState } from "react";
import { Button } from "reactstrap";
import { ThemeContext } from "../../contexts/ThemeContext";
import ErrorBoundary from "../general/ErrorBoundary";
import GeneralNavbar from "../general/GeneralNavbar";
import PsychometricService from "../../services/PsychometricService";
import { PsychometricContext } from "../../contexts/PsychometricContext";
import PsychometricTestNavbar from '../psychometric/PyschometricTestNavbar';
const PsychometricTestCheckbox = ({  
   goToNextStep, 
  goToPreviousStep, 
  history, 
  location,
  isOrganization,
  signedID,
  signedFirstName,
  signedLastName,
  signedOrganization,
  signedEmail,
  ...props  }) => {
  const { theme, fontFamily, colors, fontWeight } = useContext(ThemeContext);
  const [interests, setInterests] = useState([]);
  const [selectedInterests, setSelectedInterests] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [currentInterestIndex, setCurrentInterestIndex] = useState(0);
  const isIframe = new URLSearchParams(location.search).get('iframe') === 'true';

  useEffect(() => {


      // Validate required parameters based on user type
      if (isOrganization === true) {
        if (!signedOrganization || !signedFirstName || !signedLastName || !signedID) {
          console.log("Redirecting due to missing organization parameters...");
          history.replace("/psychometricSignIn");
          return;
        }
      } else {
        if (!signedEmail) {
          console.log("Redirecting due to missing email...");
          history.replace("/psychometricSignIn");
          return;
        }
      }
    const fetchInterests = async () => {
      try {
        const response = await PsychometricService.getPsychometricTest("english");
        const section = response.test.sections.find((section) => section.number === "4");
        const interestsObj = section.properties;
        setInterests(interestsObj);
        setIsLoading(false);
      } catch (error) {
        console.error("Error loading interests:", error);
      }
    };

    fetchInterests();
  }, [signedEmail, isOrganization, signedOrganization, signedID, signedFirstName, signedLastName, history]);

  const handleInterestChange = (interestIndex) => {
    setSelectedInterests((prevSelectedInterests) => {
      const updatedSelectedInterests = { ...prevSelectedInterests };
      const indexExists = updatedSelectedInterests[interestIndex];

      if (indexExists) {
        delete updatedSelectedInterests[interestIndex];
      } else {
        updatedSelectedInterests[interestIndex] = true;
      }

      updateInterestsOnServer(interestIndex, !indexExists);

      return updatedSelectedInterests;
    });
  };

  const updateInterestsOnServer = async (interestIndex, checked) => {
    try {
      const sectionLetter = String.fromCharCode(65 + currentInterestIndex);
    
     
      if(isOrganization){
        await PsychometricService.updateInterestsAnswers({
          uniqueID: signedID,
          firstName: signedFirstName,
          lastName: signedLastName,
          organization: signedOrganization,
          sectionLetter: sectionLetter,
          checkedIndex: interestIndex,
          checked: checked,
        });

      }else{

        await PsychometricService.updateIndividualInterestsAnswers({
          email: signedEmail,
          sectionLetter: sectionLetter,
          checkedIndex: interestIndex,
          checked: checked,
        });

      }
     

    } catch (error) {
      console.error("Error updating interests on server:", error);
    }
  };

  const handleNextInterest = () => {
    setCurrentInterestIndex((prevIndex) =>
      Math.min(prevIndex + 1, Object.keys(interests).length - 1)
    );
  };

  const handlePreviousInterest = () => {
    setCurrentInterestIndex((prevIndex) => Math.max(prevIndex - 1, 0));
  };

  const handleNextPage = async (e) => {
    e.preventDefault();
    console.log("Next Page button clicked");
    goToNextStep();
  };

  const handlePreviousPage = (e) => {
    e.preventDefault();
    console.log("Previous Page button clicked");
    goToPreviousStep();
  };

  // Calculate the progress percentage
  const minProgressPercentage = 40;
  const maxProgressPercentage = 60;
  const totalInterests = Object.keys(interests).length;
  const progressPercentage = minProgressPercentage + ((currentInterestIndex / (totalInterests - 1)) * (maxProgressPercentage - minProgressPercentage));

  return (
    <div style={{ fontFamily: fontFamily.primary, color: colors.text }}>
            {isIframe && (
                <ErrorBoundary errorAt="At PsychometricTestCheckbox PsychometricTestNavbar">
                    <PsychometricTestNavbar signedOrganization={signedOrganization} />
                </ErrorBoundary>
            )}
            {!isIframe && (
                <ErrorBoundary errorAt="At General  PsychometricTestCheckbox GeneralNavbar">
               <PsychometricTestNavbar signedOrganization={signedOrganization} />
                </ErrorBoundary>
            )}
      <div
        className="progress"
        style={{ height: "10px", marginBottom: "10px" }}
      >
        <div
          className="progress-bar bg-success"
          role="progressbar"
          style={{
            width: `${progressPercentage}%`,
            background:
              "linear-gradient(to right, #28a745 20%, transparent 20%)",
          }}
          aria-valuenow={progressPercentage}
          aria-valuemin="0"
          aria-valuemax="100"
        ></div>
      </div>
      <div className="row p-3 px-5">
        <h1
          className="col-md-12 col-12 mb-3"
          style={{
            fontWeight: fontWeight.bold,
            fontSize: "1.5rem",
            color: colors.primaryGreenDark,
          }}
        >
          Psychometric Test: Your Interests
        </h1>

        {isLoading ? (
          <div
            className="col-md-12 col-12 mb-4"
            style={{ textAlign: "center" }}
          >
            Loading...
          </div>
        ) : (
          <div className="col-md-12 col-12 mb-4" style={{ textAlign: "left" }}>
            <form>
              <h3 style={{ 
                marginBottom: "10px",
                fontSize: "calc(1.1rem + 0.3vw)"
              }}>
                {`${currentInterestIndex + 1}/${totalInterests} Section ${String.fromCharCode(65 + currentInterestIndex)}`}
              </h3>
              <p className="text-muted" style={{ 
                fontSize: 'clamp(0.8rem, 0.7rem + 0.5vw, 0.9rem)',
                marginBottom: "20px",
                fontStyle: 'italic'
              }}>
                Select all that is applicable
              </p>
              {interests[`interests${String.fromCharCode(65 + currentInterestIndex)}`] &&
                Object.entries(interests[`interests${String.fromCharCode(65 + currentInterestIndex)}`]).map(([key, value]) => (
                  <div key={key} style={{ marginBottom: "18px" }}>
                    <label style={{ display: "inline-block", marginRight: "10px" }}>
                      <input
                        type="checkbox"
                        checked={selectedInterests[key] || false}
                        onChange={() => handleInterestChange(key)}
                        style={{ marginRight: "5px" }}
                      />
                      {value}
                    </label>
                  </div>
                ))}
              <div className="mt-4 d-flex justify-content-between">
                <Button
                id="previousInterestButton"
                  type="button"
                  color="secondary"
                  onClick={handlePreviousInterest}
                  disabled={currentInterestIndex === 0}
                  style={theme.newButtonRounded}
                >
                  Back
                </Button>
                <Button
                id="nextInterestButton"
                  type="button"
                  color="secondary"
                  onClick={handleNextInterest}
                  disabled={currentInterestIndex === Object.keys(interests).length - 1}
                  style={theme.newButtonRounded}
                >
                  Next
                </Button>
              </div>
              {currentInterestIndex === Object.keys(interests).length - 1 && (
                <div className="mt-4 d-flex justify-content-between">
                  <Button
                    id="nextPageButton"
                    type="button"
                    color="primary"
                    onClick={handleNextPage}
                    style={theme.formSubmit}
                  >
                    Next Page
                  </Button>
                </div>
              )}
            </form>
          </div>
        )}
      </div>
      <footer style={theme.psychometricTestFooter}>
                Powered by Umang Wellness
        </footer>
    </div>
  );
};

export default PsychometricTestCheckbox;
